// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import afishEntity from './entities/afish.json';
import afishMenu from '../pages/afish/menu.json';
import afishFullForm from '../pages/afish/forms/full.json';
import afishContextForm from '../pages/afish/forms/context.json';
import afishMiniForm from '../pages/afish/forms/mini.json';
import afishLookupForm from '../pages/afish/forms/lookup.json';
import afishTableView from '../pages/afish/views/table.json';
import afishStagesView from '../pages/afish/views/stages.json';
import afishCardsView from '../pages/afish/views/cards.json';
import afishInlineView from '../pages/afish/views/inline.json';
import afishBacklogView from '../pages/afish/views/backlog.json';
import afishSplitView from '../pages/afish/views/split.json';
import afishCalendarView from '../pages/afish/views/calendar.json';
import afishDashboardView from '../pages/afish/views/dashboard.json';

/** Тип запису «Причина» зі сторінками пакета: меню, форми та подання з pages/afish/. */
export const afishDefinition: IRecordTypeDefinition = {
  ...afishEntity,
  views: assembleViewSet({
      table: afishTableView,
      stages: afishStagesView,
      cards: afishCardsView,
      inline: afishInlineView,
      backlog: afishBacklogView,
      split: afishSplitView,
      calendar: afishCalendarView,
      dashboard: afishDashboardView,
  }),
  form: afishFullForm,
  forms: { full: afishFullForm, context: afishContextForm, mini: afishMiniForm, lookup: afishLookupForm },
  menu: afishMenu,
} as IRecordTypeDefinition;
